import { PopupContent } from "semantic-ui-react";
import { Popup } from "semantic-ui-react";
import { getCurrentOffice } from "../selectors/offices";
import React from 'react'
import scopedRecordSchema from "./scopedRecordSchema";


const invoiceConfigurationSchema = function(state, props) {
  let hideScopeSelection = state.view !== 'admin' && !props.readonly

  let ApiKeyPopupTrigger =
    <a className={"api-key-label-button"}>
      {I18n.t('api.forms.invoice_configuration.what_is_peppyrus_api_key')}
    </a>

  let ApiKeyPopupContent =
    <PopupContent>
      {I18n.t('api.forms.invoice_configuration.peppyrus_api_key_explainer')}
      <br/>
      <a className={"api-key-popup-button"} href="/files/pdf/Gids Peppyrus-integratie.pdf" download>
        {I18n.t('api.forms.invoice_configuration.peppyrus_api_key_explainer_link')} </a>
      {I18n.t('api.forms.invoice_configuration.peppyrus_api_key_explainer_part2')}
    </PopupContent>

  let ApiKeyLabel =
    <label>
      Peppyrus API Key
      &nbsp;
      <Popup wide='very' trigger={ApiKeyPopupTrigger} on={'click'} content={ApiKeyPopupContent}/>
    </label>

  let office = getCurrentOffice(state)
  let freeFromEnterprise = office && office.hiddenPreferences && office.hiddenPreferences.includes("freeFormEnterpriseNumber")
  return {
    "ui:readonly": props.readonly,
    "enterpriseNumber": {
      "ui:autofocus": true,
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:widget": "MaskedTextWidget",
      "ui:options" : {
        mask: freeFromEnterprise ? false : [/\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/],
        width: 4
      }
    },
    "iban": {
      "ui:autofocus": true,
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:widget": "MaskedTextWidget",
      "ui:options" : {
        width: 4,
        mask:  function(rawValue) {
          let beMask = ['B', 'E']
          let otherCountryMask = [/[a-zA-Z]/, /[a-zA-Z]/]
          let usedCountryMask = (isNaN(rawValue.charAt(0))) ? otherCountryMask : beMask

          let beDigitsMask = [ /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]
          let nlDigitsMask = [ /\d/, /\d/, ' ', /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/]
          let otherDigitsMask = new Array(Math.max(rawValue.replace(/_/g, '').length - 2, 0)).fill(/[a-zA-Z0-9 ]/)
          let usedDigitsMask = beDigitsMask

          if(rawValue.length >= 2 && !rawValue.toUpperCase().startsWith('BE')){
            if (rawValue.toUpperCase().startsWith('NL')) {
              usedDigitsMask = nlDigitsMask
            } else{
              usedDigitsMask = otherDigitsMask
            }
          }

          return usedCountryMask.concat(usedDigitsMask)
        },
        pipe: function(value){
          return value.toUpperCase()
        }

      }
    },
    "invoiceConditions": {
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:widget": "DraftWidget"
    },
    "invoiceMessage": {
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:widget": "DraftWidget"
    },
    "startInvoiceIdentification": {
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:widget": "UpDownWidget",
      "ui:options": {
        width: 2
      },
    },
    "peppyrusApiKey":{
      "ui:label": ApiKeyLabel,
      "ui:options": {
        width: 8
      },
    },
    ...scopedRecordSchema(state,props)
  }
}

export default invoiceConfigurationSchema;
